import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { PageTabs } from "@/components/ui/page-tabs";
import Edit from "./edit";
import { History } from "./history";
import { AssociationsTab } from "../../components/associations-tab";

type TabKey = "details" | "history" | "asociaciones";

const ExternalUserDetails = () => {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState<TabKey>("details");

  const tabs = [
    { label: "Detalles", key: "details" },
    // "Asociaciones" tab is hidden (JER-453): associations are consulted from
    // the "Detalles" tab via "Ver detalle". The tab content is kept below so it
    // can be re-enabled easily if needed.
    // { label: "Asociaciones", key: "asociaciones" },
  ];

  const handleTabChange = (key: string) => {
    setActiveTab(key as TabKey);

    if (key === "history") {
      queryClient.invalidateQueries({ queryKey: ["admin-log-list"] });
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <PageTabs
        tabs={tabs}
        activeKey={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && <Edit />}
      {activeTab === "history" && <History />}
      {activeTab === "asociaciones" && <AssociationsTab />}
    </div>
  );
};

export default ExternalUserDetails;
